import { getTopLevelPath } from "lib/getTopLevelPath"

export function getCurrentShellBasePath(topLevelPath = getTopLevelPath()) {
    if (topLevelPath === "authoring") return "/authoring"
    return "/app"
}
